<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <Button icon="ios-arrow-back" size="small" class="mr20" @click="$router.go(-1)">返回</Button>
        <span class="ivu-page-header-title mr20" v-text="$route.meta.title"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="formData" :model='formData' label-position="right" :label-width="200" :rules="ruleValidate"
            @submit.native.prevent>
        <Row :gutter="24" type="flex">

          <Col span="24">
            <FormItem label="所属基地" prop="land_base_id">
              <Select v-model="formData.land_base_id" placeholder="请选择所属基地" class="perW30">
                <Option v-for="(item,key) in landBaseList" :value="key" :key="key">{{ item }}</Option>
              </Select>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="用户姓名" prop="name">
              <Input placeholder="请输入用户姓名" class="perW30" v-model="formData.name"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="手机号/账号" prop="phone">
              <Input placeholder="请输入手机号/账号" class="perW30" v-model="formData.phone"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="密码" prop="password">
              <Input placeholder="请输入密码" class="perW30" v-model="formData.password"></Input>
              <span style="color: #9b9b9b;margin-left: 10px;">密码长度为6-18位, 仅支持字母+数字, 添加新账户密码可不输入, 默认为123456</span>
            </FormItem>
          </Col>

        </Row>

        <FormItem>
          <Button type="primary" class="submission" @click="submit">提交</Button>
        </FormItem>

      </Form>
    </card>

  </div>
</template>
<script>
import {landBaseUserSaveApi, landBaseUserInfoApi} from '@/api/landBase/landBaseUser'
import {landBaseAllApi} from "@/api/landBase/landBase";

export default {
  name: 'landBaseUserEdit',
  data() {
    return {
      formData: {
        land_base_user_id: 0,
        land_base_id: 0,
        name: '',
        phone: '',
        password: '',
      },
      ruleValidate: {
        land_base_id: [
          {required: true, message: '请选择所属基地', trigger: 'change'}
        ],
        name: [
          {required: true, type: 'string', message: '请输入用户姓名', trigger: 'blur'},
          {min: 1, max: 4, message: '请输入1-4位字符', trigger: 'blur'}
        ],
        phone: [
          {required: true, type: 'string', message: '请输入手机号/账号', trigger: 'blur'},
          {len: 11, message: '请输入11位的数字', trigger: 'blur'}
        ],
        password: [
          {required: false, min: 6, max: 18, message: '请输入6-18位密码', trigger: 'blur'}
        ],
      },
      landBaseList: [],
    }
  },
  mounted() {
    this.loadLandBaseData()
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.loadFormData(this.$route.params.id)
    }
  },
  methods: {
    //提交数据
    submit() {
      // 验证数据
      this.$refs.formData.validate((valid) => {
        if (!valid) {
          this.$Message.error('请检查输入内容!')
          return false
        } else {
          //请求接口
          landBaseUserSaveApi(this.formData).then(res => {
            if (res.code === 200) {
              this.$Message.success('成功')
              setTimeout(() => {
                this.$router.go(-1)
              }, 500)
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })

    },

    // 编辑加载数据
    loadFormData(id) {
      landBaseUserInfoApi(id).then(res => {
        //数据赋值
        this.formData = res.data

        // 字符串转换
        this.formData.land_base_id = this.formData.land_base_id.toString()

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

    // 所有基地
    loadLandBaseData() {
      landBaseAllApi().then(res => {
        if (res.code === 200) {
          this.landBaseList = res.data
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

  }
}
</script>
